var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MapModal',{staticClass:"newModelPosition hierarchy2",attrs:{"modalNode":_vm.modalNode,"title":_vm.title == 'add' ? '新增施工时区' : '编辑施工时区',"close":_vm.close,"submitData":_vm.submitData,"submit":_vm.submit,"id":"timeBlock"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }